let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2wfqp")).then(() => parcelRequire('8gyyU'));